import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LivetrainingService } from '../shared/services/livetraining.service';
import * as CryptoJS from 'crypto-js';
import { Title, DomSanitizer } from "@angular/platform-browser";
import { CommonapiService } from '../shared/services/commonapi.service';
//jquery declaration
declare var $: any;

@Component({
  selector: 'app-traininglogin',
  templateUrl: './traininglogin.component.html',
  styleUrls: ['./traininglogin.component.css']
})
export class TrainingloginComponent implements OnInit {

  conversionDecryptOutput: string = '';
  encPassword: string = '';
  eventDetails: any = [];
  trainingCode: string = "";
  msg = "";

  constructor(
    private activeRoute: ActivatedRoute,
    private service: LivetrainingService,
    private titleService: Title,
    public router: Router,
    private commonApiService: CommonapiService,
  ) { }

  async ngOnInit() {
    await this.activeRoute.params.subscribe(async routeParams => {
      this.conversionDecryptOutput = CryptoJS.AES.decrypt(routeParams.id.toString(), this.encPassword).toString(CryptoJS.enc.Utf8);

      await this.service.getEvents().then(Data => {
        this.eventDetails = Data.filter(x => x.id == parseInt(this.conversionDecryptOutput))[0];
        console.log(this.eventDetails);

        this.titleService.setTitle(this.eventDetails.coursename + " - SFI Compliance, Inc");
        this.topposition();
      })
    });
  }

  async trainingCodeSubmit() {

    await this.activeRoute.params.subscribe(async routeParams => {
      this.conversionDecryptOutput = CryptoJS.AES.decrypt(routeParams.id.toString(), this.encPassword).toString(CryptoJS.enc.Utf8);

      const _obj = {
        UniqueTrainingTrackerID: this.trainingCode,
        TrainingTrackerID: this.conversionDecryptOutput,
      };

      //console.log(_obj);

      let _dt = await this.commonApiService.postData("api/TrainingApi/DBValidateTrainingTrackerUniqueID/", _obj).toPromise();

      console.log(_dt);
      if (_dt && _dt[0] && _dt[0].dataSet.message !== "Incorrect Unique Code! Please Contact Instructor for Correct Unique Code!") {
        this.msg = "";
        this.router.navigate(["/trainingentry", { id: routeParams.id.toString(),course: this.eventDetails.coursename }]);
      }
      else if (_dt && _dt[0] && _dt[0].dataSet.message === "Incorrect Unique Code! Please Contact Instructor for Correct Unique Code!") {
        this.msg = _dt[0].dataSet.message;
      }





    });


  }

  keyPress(event: KeyboardEvent) {
    const pattern = /[0-9]/;
    //const inputChar = String.fromCharCode(event).charCode);
    // if (!pattern.test(inputChar)) {    
    //     // invalid character, prevent input
    //     event.preventDefault();
    // }
  }

  topposition() {
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
  }
}
